var map = {
	"./bonus_symbol_0.png": "1fd0",
	"./bonus_symbol_1.png": "0cf0",
	"./bonus_symbol_2.png": "e551",
	"./bonus_symbol_3.png": "21bf",
	"./bonus_symbol_4.png": "c280"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "70e1";